// Profile of Alina Tselinina, French. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina est ingénieure logiciel avec une formation en ingénierie des données, en mathématiques appliquées et en apprentissage automatique ; elle travaille aujourd’hui sur des applications reposant sur l’IA et des systèmes agentiques. Elle a de l’expérience dans la création d’API et de pipelines de données, la modernisation d’applications par la migration vers le cloud et le développement de services reposant sur le ML. Elle s’attache à relier les LLM et les agents d’IA à des systèmes logiciels fiables grâce à des workflows structurés, des intégrations, des tests et une évaluation itérative.',
  imageAlt: 'Portrait d’Alina Tselinina',
  personal: {
    languages: 'Anglais, polonais',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Études : mathématiques financières et actuarielles',
      institution: 'Université Adam-Mickiewicz, Poznań',
      degree: 'Diplôme : master'
    },
    {
      period: '2009 - 2014',
      field: 'Études : mathématiques',
      institution: 'Université d’État de Biélorussie, Minsk',
      degree: 'Diplôme : licence'
    }
  ],
  skills: [
    {
      title: 'Programmation',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'IA et LLM',
      description: 'Claude, MCP, agents d’IA, adaptation de LLM, entraînement et évaluation de modèles'
    },
    {
      title: 'Cloud et données',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Frameworks et API',
      description: 'FastAPI, Flask, Shiny, API REST, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Ingénierie des données et DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Bases de données et orchestration',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Outils Atlassian',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'Depuis mars 2026',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Ingénierie d’agents d’IA, configuration de workflows et intégration d’outils.',
        'Adaptation de LLM, entraînement et évaluation de modèles.',
        'Développement et intégration d’applications reposant sur l’IA.',
        'Informatique quantique : contribution au développement logiciel pour des applications quantiques.'
      ]
    },
    {
      period: 'Depuis mai 2025',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'Développement d’applications.',
        'Mise en œuvre de tests unitaires et de tests d’interface utilisateur pour soutenir la qualité des applications.'
      ]
    },
    {
      period: 'Novembre 2022 - février 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Maintenance et amélioration de pipelines de données et de l’orchestration de workflows.',
        'Développement de packages pour l’automatisation de rapports.'
      ]
    },
    {
      period: 'Juillet 2022 - octobre 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Développement et maintenance de pipelines ETL.'
      ]
    },
    {
      period: 'Mars 2022 - juin 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Conception et développement d’API REST et de services back-end.',
        'Implémentation de la logique backend de traitement JSON.'
      ]
    },
    {
      period: 'Novembre 2020 - mars 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Conception et développement d’API REST et de services back-end (preuve de concept).',
        'Développement et maintenance de pipelines ETL.',
        'Modernisation d’applications sur site par une migration vers AWS et la réécriture de code R en Python.',
        'Validation XML et transformation en HTML.',
        'Développement d’applications web.'
      ]
    },
    {
      period: 'Mai 2020 - novembre 2020',
      title: 'Data Scientist, PSI Polska, Poznań',
      description: [
        'Conception et développement d’API REST et de services back-end avec un modèle d’apprentissage automatique en back-end.',
        'Développement d’un modèle de segmentation de la clientèle.'
      ]
    },
    {
      period: 'Janvier 2019 - avril 2020',
      title: 'Advanced Data Scientist, Analyx, Poznań',
      description: [
        'Web scraping et développement de pipelines de données.',
        'Développement d’applications web.',
        'Modélisation du mix marketing.',
        'Optimisation des flux de travail.'
      ]
    },
    {
      period: 'Mai 2018 - décembre 2018',
      title: 'Data Scientist, Poznań',
      description: [
        'Développement d’un processus ETL.',
        'Maintenance de scripts Bash.',
        'Support client et analyses ad hoc.'
      ]
    },
    {
      period: 'Avril 2017 - avril 2018',
      title: 'Junior Analyst, Poznań',
      description: [
        'Analyse de données et création de rapports.',
        'Rédaction de documentation et préparation de présentations.'
      ]
    }
  ]
};
